import { environment } from '../../../environments/environment';

export const API_BASE_URL = environment.apiUrl;

export const ENDPOINTS = {
  GET_ORG_DATA: `${API_BASE_URL}/api/public/enrollment/v1/getOrgListForProgram/{program_code}`,
  CHECK_DUPS_DATA: `${API_BASE_URL}/api/public/enrollment/v1/dupsCheck/{flow}`,
  GET_LOOKUP_VALUES: `${API_BASE_URL}/api/public/enrollment/v1/getLookupValues`,
  GET_NOTIFICATIONS: `${API_BASE_URL}/api/v1/getNotificationMessage/{program_code}/{userType}`,
  SAVE_LEAD: `${API_BASE_URL}/api/public/enrollment/v1/save{flow}Lead`,
  GET_TAS_LOOKUP_VALUES: `${API_BASE_URL}/clmapi/claims/servicecode/v1/getTasLookupValues`,
  UNMASK_Identifier: `${API_BASE_URL}/api/{program_code}/v1/unmask`,
  SEND_NOTIFICATION: `${API_BASE_URL}/api/v1/cmnctn/sendCommunication`,
  SEND_NOTIFICATION_WITH_IDS: `${API_BASE_URL}/api/enrollment/v1/sendCommunication`,
  CLAIMS: {
    GET_SERVICE_DATA: `${API_BASE_URL}/clmapi/public/claims/servicecode/v1/{programCode}/serviceCodesAndOrganizations`,
    AUTH_FILE_UPLOAD: `${API_BASE_URL}/api/common/v1/authFileAttachment`,
    AUTH_FILE_DELETE: `${API_BASE_URL}/api/common/v1/deleteDocument/{program}/auth/{id}`,
  },
  COMMON: {
    UPLOAD_FILE: `${API_BASE_URL}/api/upload/v1/fileUpload`,
    DELETE_FILE: `${API_BASE_URL}/api/upload/v1/deleteFileUpload/{program}/{type}/{id}/{createType}`,
  }
};

export const EXCLUDE_LOADER_URLS = ['https://api.addressy.com/'];


export const MENU_BASE_URLS = {
  PARTICIPANT_LEADS: 'participantLeadsList',
  PROVIDER_LEADS: 'providerLeadsList',
  GLOBAL_PARTICIPANT_SEARCH: 'globalConsumerSearch',
  REFERRAL: 'referralList',
  PARTICIPANT_ENROLLMENT: 'participantEnrollmentList',
  PROVIDER_ENROLLMENT: 'providerEnrollmentList',
  PROCESS_CODES: 'processCodeList',
  EXTERNAL_MEMBERS: 'enrollmentDetails',
  AUTHORIZATIONS: 'authorizations',
}

